import { useUser } from 'features/auth/hooks/useUser';

export const useOrgType = (type: 1 | 2) => {
  const { data } = useUser();
  const hasAccess = data?.loginContext?.organizationType === type;
  return hasAccess;
};

export const useGetOrgType = () => {
  const { data } = useUser();
  return data?.loginContext?.organizationType;
};

export const useOrgId = () => {
  const { data } = useUser();
  return data?.loginContext?.organizationId;
};
